import { useRef } from "react";

/** Horizontal swipe paging, ignored while the image is zoomed in. */
export const useSwipeNav = ({ zoom, onPrev, onNext }) => {
  const touchX = useRef(null);

  return {
    onTouchStart: (e) => {
      if (e.touches.length === 1) touchX.current = e.touches[0].clientX;
    },
    onTouchEnd: (e) => {
      if (touchX.current === null || zoom > 1) return;
      const dx = e.changedTouches[0].clientX - touchX.current;
      touchX.current = null;
      if (dx < -60 && onNext) onNext();
      else if (dx > 60 && onPrev) onPrev();
    },
  };
};
